export default __webpack_public_path__ + "static/media/logo.f7ca03eb.svg";